import { render } from "./fabricCompositions.vue?vue&type=template&id=6d278026&ts=true"
import script from "./fabricCompositions.vue?vue&type=script&lang=ts"
export * from "./fabricCompositions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__